// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1mok{border-radius:var(--ds-radius-large,8px)}\n._18zrpxbi{padding-inline:var(--ds-space-200,1pc)}._154i1ejb{top:var(--ds-space-300,24px)}\n._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}\n._1ltvpxbi{left:var(--ds-space-200,1pc)}\n._1q51xy5q{padding-block-start:var(--ds-space-400,2pc)}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
